import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import scrollToComponent from 'react-scroll-to-component';

import {getJsonFromUrl} from '../../../utils/url';

import * as productActionCreators from '../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import {ProductGridContainer} from '../gallery/blocks/results/grids/ProductGrid';

class SearchResults extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let urlData = getJsonFromUrl();
    let hasQuerystring = Object.entries(urlData).length > 0 && urlData.constructor === Object;

    console.log(urlData);

    let searchQuery = '';
    if(hasQuerystring && urlData.q) {
      searchQuery = urlData.q;
    }

    const initPageVal = hasQuerystring && urlData.p ? urlData.p : null;

		this.state = {
      searchQuery: searchQuery,
      searchResults: [],
      searchCount: 0,
      hasSearched: false,
      searchPending: false,
      sortValue: '',
      initPage: initPageVal,
    }
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Search Results';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";

    if(this.state.searchQuery) {
      this.fetchSearchResults(true);
    }

    if(window.location.host.indexOf('staging') >= 0) {  
      cls_InovaDiamonds_Iframe.put_Flag_Cataloge();
      cls_InovaDiamonds_Iframe.init_Session();
    }
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeSearchQuery(evt) {
    this.setState({ searchQuery: evt.target.value });
  }

  keyPressSearch(evt) {
    if(evt.key === 'Enter') {
      this.fetchSearchResults();
    }
  }

  fetchSearchResults(firstCall = false) {
    if(this.state.searchQuery) {

      if(firstCall === true) {
        this.props.productSetPage(this.state.initPage ? parseInt(this.state.initPage) : 1);
      } else {
        this.props.productSetPage(1);
      }

      let searchString = this.state.searchQuery.toLowerCase();
      if(searchString.toLowerCase().includes('paper clip')) {
        searchString = searchString.replace('paper clip', 'paperclip');
      }
      if(searchString.toLowerCase().includes('fresh water')) {
        searchString = searchString.replace('fresh water', 'freshwater');
      }
      if(searchString.toLowerCase().includes('three stone')) {
        searchString = searchString.replace('three stone', 'three-stone');
      }
      if(searchString.toLowerCase().includes('5 stone')) {
        searchString = searchString.replace('5 stone', 'five-stone');
      }
      if(searchString.toLowerCase().includes('5-stone')) {
        searchString = searchString.replace('5-stone', 'five-stone');
      }
      if(searchString.toLowerCase().includes('five stone')) {
        searchString = searchString.replace('five stone', 'five-stone');
      }
      if(searchString.toLowerCase().includes('3 stone')) {
        searchString = searchString.replace('3 stone', 'three-stone');
      }
      if(searchString.toLowerCase().includes('3-stone')) {
        searchString = searchString.replace('3-stone', 'three-stone');
      }
      if(searchString.toLowerCase().includes('four row')) {
        searchString = searchString.replace('four row', 'four-row');
      }
      if(searchString.toLowerCase().includes('five row')) {
        searchString = searchString.replace('five row', 'five-row');
      }
      if(searchString.toLowerCase().includes('tri tone')) {
        searchString = searchString.replace('tri tone', 'tri-tone');
      }
      if(searchString.toLowerCase().includes('tritone')) {
        searchString = searchString.replace('tritone', 'tri-tone');
      }
      if(searchString.toLowerCase().includes('two tone')) {
        searchString = searchString.replace('two tone', 'two-tone');
      }
      if(searchString.toLowerCase().includes('anniversary bands')) {
        searchString = searchString.replace('anniversary bands', 'anniversary band');
      }
      if(searchString.toLowerCase().includes('eternity bands')) {
        searchString = searchString.replace('eternity bands', 'eternity band');
      }
      if(searchString.toLowerCase().includes('wedding bands')) {
        searchString = searchString.replace('wedding bands', 'wedding band');
      }
      if(searchString.toLowerCase().includes('hoops')) {
        searchString = searchString.replace('hoops', 'hoop');
      }
      if(searchString.toLowerCase().includes('chains')) {
        searchString = searchString.replace('chains', 'chain');
      }
      if(searchString.toLowerCase().includes('pavé')) {
        searchString = searchString.replace('pavé', 'pavÃ©');
      }
      if(searchString.toLowerCase().includes('pave')) {
        searchString = searchString.replace('pave', 'pavÃ©');
      }

      this.setState({
        searchResults: [],
        searchCount: 0,
        hasSearched: true,
        searchPending: true,
      }, () => {
        console.log(searchString);
        this.props.productFetchSearchResults(searchString, this.state.sortValue)
        .then((resp) => {
            
          const prodResp = resp.success.products;
          const prodCount = resp.success.count;

          this.props.productFetchDiamondById(this.state.searchQuery)
          .then((respData) => {

            const diamondResp = respData;
            diamondResp['product_type'] = 'diamond';
            
            this.setState({
              searchResults: prodResp.push(diamondResp),
              searchCount: prodCount + 1,
              searchPending: false,
            });
          })
          .catch((errResp) => {
            if(resp && resp.success) {
              this.setState({
                searchResults: prodResp,
                searchCount: prodCount,
                searchPending: false,
              });
            }
          });
        })
      });
    }
  }

  scrollToResults() {
    if(!this.resultsSection) { return; }
    scrollToComponent(this.resultsSection, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  updateMethod(sortVal) {
    this.setState({ sortValue: sortVal }, () => {
      this.fetchSearchResults();
    });
  }

  render() {

    return <div className='SearchResults'>
      <div className='searchTitle'>Diamonds Direct Search</div>
      <div className='searchControls'>
        <div className='inputWrapper'>
          <input
            type='text'
            placeholder='Search Diamonds Direct'
            value={this.state.searchQuery}
            onChange={::this.changeSearchQuery}
            onKeyPress={::this.keyPressSearch} />
        </div>
        <div className='buttonWrapper'>
          <div className='searchIconButton' onClick={::this.fetchSearchResults}>
            <div className='buttonIcon'>
              <img src='https://ddw2.diamondsdirect.com/img/search/search_icon.svg' />
            </div>
            <div className='buttonText'>Search</div>
          </div>
        </div>
      </div>      

      <div className='resultsWrapper' ref={(div) => { this.resultsSection = div; }}>
        <div className='resultsTabWrapper'>
          <div className={'resultTab selectedTab'}>Search Results</div>
        </div>
        <div className='resultsBody' ref={(div) => { this.resultsBody = div; }}>
          {!this.state.hasSearched ?
            <div className='searchPrompt'>Enter query above to search Diamonds Direct.</div> :
            <div>
              <ProductGridContainer 
                updateMethod={::this.updateMethod} 
                scrollUp={::this.scrollToResults}
                searchPending={this.state.searchPending}
                products={this.state.searchResults}
                productCount={this.state.searchCount}
                searchQuery={this.state.searchQuery} />   
            </div>
          }
        </div>
      </div>

    </div>;
	}
}
export default SearchResults;

function mapStateToProps(state) {
  return {

  };
}

export const SearchResultsContainer = connect(
  mapStateToProps,
  allActionCreators
)(SearchResults);


// WEBPACK FOOTER //
// ./src/components/views/search/SearchResults.jsx